import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { submitOmraDemande } from '../services/kafalaService';
import './SaqyaWellRequest.css';

const emptyForm = {
  first_name: '',
  last_name: '',
  phone: '',
  ville: '',
};

const OmraRequest = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);
    setSaving(true);
    try {
      await submitOmraDemande(form);
      setForm(emptyForm);
      setSuccess(true);
    } catch (err) {
      const data = err.response?.data;
      setError(data?.message || t('omraForm.sendError'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section id="omra-request" className="program-section program-section--alt saqya-well omra-request">
      <div className="program-section__inner saqya-well__inner">
        <button type="button" className="saqya-well__cta" onClick={() => { setOpen(true); setSuccess(false); setError(''); }}>
          {t('omraForm.button')}
        </button>
      </div>

      {open ? (
        <div className="saqya-well-modal" onClick={() => setOpen(false)} role="presentation">
          <div
            className="saqya-well-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="omra-request-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="saqya-well-modal__x"
              onClick={() => setOpen(false)}
              aria-label={t('omraForm.close')}
            >
              <FaTimes />
            </button>
            <h3 id="omra-request-title">{t('omraForm.title')}</h3>
            <form onSubmit={onSubmit} className="saqya-well-modal__form">
              <label>
                {t('omraForm.lastName')}
                <input name="last_name" value={form.last_name} onChange={onChange} required />
              </label>
              <label>
                {t('omraForm.firstName')}
                <input name="first_name" value={form.first_name} onChange={onChange} required />
              </label>
              <label>
                {t('omraForm.phone')}
                <input name="phone" type="tel" value={form.phone} onChange={onChange} required dir="ltr" />
              </label>
              <label>
                {t('omraForm.city')}
                <input name="ville" value={form.ville} onChange={onChange} required />
              </label>
              {error ? <p className="saqya-well-modal__error">{error}</p> : null}
              {success ? <p className="saqya-well-modal__success">{t('omraForm.success')}</p> : null}
              <button type="submit" disabled={saving}>
                {saving ? t('omraForm.sending') : t('omraForm.submit')}
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default OmraRequest;
